import { Auth } from 'aws-amplify';

const baseURL = import.meta.env.VITE_APP_ACCOUNTS_APP_RUNNER_BASE_URL;
// const baseURL = 'http://localhost:3001/api';

async function getToken() {
  const currentSession = await Auth.currentSession();
  const { idToken } = currentSession;
  return idToken.jwtToken;
}

export async function getAPI({ url = '', params }) {
  const urlParams = new URLSearchParams(params);
  const urlWithParams = `${baseURL}/whatsNew/${url}?${urlParams.toString()}`;
  const token = await getToken();
  const response = await fetch(urlWithParams, {
    headers: {
      'x-auth-token': token
    }
  });
  return response.json();
}

export async function postAPI({ body, params }) {
  const urlParams = new URLSearchParams(params);
  const urlWithParams = `${baseURL}/whatsNew?${urlParams.toString()}`;
  const token = await getToken();
  const response = await fetch(urlWithParams, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token
    },
    body: JSON.stringify(body)
  });
  return response.json();
}

export async function putAPI({ body, params }) {
  const urlParams = new URLSearchParams(params);
  const urlWithParams = `${baseURL}/whatsNew?${urlParams.toString()}`;
  const token = await getToken();
  const response = await fetch(urlWithParams, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token
    },
    body: JSON.stringify(body)
  });
  return response.json();
}

export async function deleteAPI({ params, body }) {
  const urlParams = new URLSearchParams(params);
  const urlWithParams = `${baseURL}/whatsNew?${urlParams.toString()}`;
  const token = await getToken();
  const response = await fetch(urlWithParams, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token
    },
    body: JSON.stringify(body)
  });
  return response.json();
}